{
  "axes": {
    "inputsCovered": "Inputs covered",
    "needsPerson": "Person input needed",
    "withLlm": "With LLM",
    "withoutLlm": "Without LLM"
  },
  "changes": {
    "abstractStepAdded": "abstract step <step/> ({{role}})",
    "bindingAdded": "link <target/> ← <source/>",
    "bindingChanged": "link <target/>: <before/> → <after/>",
    "bindingRemoved": "link <target/> ← <source/>",
    "defaultAdded": "default <target/> = {{value}}",
    "defaultChanged": "default <target/>: {{before}} → {{after}}",
    "defaultRemoved": "default <target/> = {{value}}",
    "definitionBound": "<step/> binds <abstractStep/>: <before/> → <after/>",
    "exportAdded": "result {{name}} ← <source/>",
    "exportChanged": "result {{name}}: <before/> → <after/>",
    "exportRemoved": "result {{name}} ← <source/>",
    "none": "No changes yet.",
    "roleChanged": "<step/> step role: {{before}} → {{after}}",
    "startChanged": "<step/> start: {{before}} → {{after}}",
    "stepAdded": "step <step/> ({{role}})",
    "stepMoved": "<step/> moved",
    "stepRemoved": "step <step/>",
    "stepRepinned": "<before/> → <after/>",
    "subWorkflowAdded": "sub-schema <step/> ({{role}})",
    "textsChanged": "name or description",
    "unbound": "nothing"
  },
  "context": {
    "access": {
      "file": "file",
      "search": "search tool",
      "selection": "selection",
      "session": "session",
      "step_input": "step input",
      "whole": "whole"
    },
    "accessHelp": {
      "file": "The tool reads the file itself; nothing enters an LLM's context.",
      "search": "An MCP tool the agent calls when it needs to; only the results enter the context.",
      "selection": "A selection rule picks part of it, within its limit.",
      "session": "The agent session keeps it from turn to turn.",
      "step_input": "An earlier step's output, as big as that run made it.",
      "whole": "Rendered into the context in full."
    },
    "agentLimits": "At most {{rounds}} tool rounds and {{runs}} tool runs, {{seconds}} s.",
    "card": {
      "agent": "≈ {{tokens}} tokens known · {{tools}}",
      "model": {
        "embedding": "local embedding",
        "none": "no embedding model",
        "unknown": "embedding model use unknown"
      },
      "tool": "{{model}} · {{seconds}} s",
      "toolCount_one": "{{count}} tool",
      "toolCount_other": "{{count}} tools",
      "toolNoTimeout": "{{model}}"
    },
    "compaction": {
      "fit_to_budget_one": "Fit to budget: at most {{count}} input token.",
      "fit_to_budget_other": "Fit to budget: at most {{count}} input tokens.",
      "none": "No compaction.",
      "other": "Compaction {{method}}@{{version}}."
    },
    "contextWindow_one": "Needs a context window of {{count}} token.",
    "contextWindow_other": "Needs a context window of {{count}} tokens.",
    "find": {
      "button": "Find an artifact…",
      "search": "Search artifacts",
      "unused": "No step of this process schema reads or writes it.",
      "usedBy_one": "Used by step {{steps}}.",
      "usedBy_other": "Used by steps {{steps}}."
    },
    "from": "from <step/>, <part/>",
    "grantedWithSkills": "with skills",
    "intro": "Per step: what it reads and writes, how, and what enters an agent's context. Sizes are at the latest content version; tokens are estimates at 4 characters a token.",
    "knownTokens_one": "≈ {{count}} token known before a Run",
    "knownTokens_other": "≈ {{count}} tokens known before a Run",
    "legend": {
      "access": "How it is read",
      "resources": "What is read",
      "title": "Legend",
      "tokens": "Token figures count the prompt's own text and whole reads of known size; inputs from earlier steps and selections are known only in a run. A compaction reduces placeholders in the order shown when the input would pass its budget."
    },
    "limits": {
      "examples_by_items": "{{value}} pinned",
      "examples_by_ranking": "ranked by {{value}}",
      "examples_by_tags": "tags {{value}}",
      "filter": "filter {{value}}",
      "include_examples": "examples {{value}}",
      "include_guidelines": "guidelines {{value}}",
      "include_notes": "notes {{value}}",
      "include_sparql": "SPARQL {{value}}",
      "maximum_examples": "at most {{value}}",
      "modules": "{{value}} ontology modules",
      "path": "{{value}}",
      "render": "as {{value}}",
      "scope": "scope {{value}}",
      "tags": "tags {{value}}",
      "term_kinds": "{{value}}"
    },
    "loading": "Reading what the steps read…",
    "names": {
      "accepted_instance_data": "The project's accepted statements",
      "competency_questions": "Competency questions",
      "derived_records": "Stored vectors of the corpus version",
      "few_shot_examples": "Few-shot examples",
      "ontology_terms": "Ontology terms",
      "outputs": "Its outputs",
      "propose": "A proposed item version",
      "reference_vocabularies": "The project's reference vocabularies",
      "session": "Earlier turns",
      "source_scope": "A source selection",
      "source_version": "The Run's bound source version",
      "subject": "The Run's document or segment"
    },
    "nothing": "Nothing.",
    "ownTokens_one": "≈ {{count}} token of own text",
    "ownTokens_other": "≈ {{count}} tokens of own text",
    "panelLabel": "What each step reads and puts into context",
    "placeholders": "Placeholders",
    "promptTokens_one": "The prompt's own text: ≈ {{count}} token.",
    "promptTokens_other": "The prompt's own text: ≈ {{count}} tokens.",
    "reads": "Reads",
    "reducedAt": "reduced {{position}}.",
    "resourceHelp": {
      "artifact": "A project item read whole.",
      "change_sets": "Proposed changes and their checks.",
      "corpus": "The Run's subject document, or a source selection of the corpus.",
      "earlier_step": "The output of an earlier step of the run.",
      "examples": "Few-shot examples.",
      "label_list": "The labels an annotation step uses.",
      "model": "Ontology modules and competency questions at the content version.",
      "process_items": "Prompts, steps, process schemas and tools of the project.",
      "reference_vocabularies": "Vocabularies bound by project data role: consulted, never imported.",
      "skills": "The step's skills.",
      "step_output": "The step's own result.",
      "thread_history": "The Run's earlier turns and entries.",
      "workspace_files": "A file a tool reads in the workspace of the PC this Run runs on."
    },
    "resources": {
      "artifact": "Artifact",
      "change_sets": "Change sets",
      "corpus": "Corpus",
      "earlier_step": "Earlier step",
      "examples": "Examples",
      "knowledge_data": "Knowledge data",
      "label_list": "Label list",
      "model": "Data model",
      "process_items": "Process items",
      "reference_vocabularies": "Reference vocabularies",
      "skills": "Skills",
      "step_output": "Step output",
      "thread_history": "Run history",
      "workspace_files": "Workspace file"
    },
    "sections": "Prompt sections",
    "session": {
      "isolated": "Isolated session: no earlier turns.",
      "thread": "Run session: earlier turns stay in the agent's context."
    },
    "size": {
      "items_one": "{{count}} item",
      "items_other": "{{count}} items",
      "terms_one": "{{count}} term",
      "terms_other": "{{count}} terms",
      "unknown": "size known at run time"
    },
    "skills_one": "{{count}} skill, read on demand",
    "skills_other": "{{count}} skills, read on demand",
    "stepPage": "The step's definition",
    "stepPageNamed": "Open the step {{name}}",
    "toggle": "Resources and context",
    "tool": {
      "builtIn": "Built-in tool {{tool}}, run by the server.",
      "item": "Tool {{tool}} in the {{runtime}} sandbox.",
      "limits": "Timeout {{seconds}} s · memory {{memory}} MB · output {{output}} MB",
      "model": {
        "embedding": "Local embedding model {{model}}.",
        "none": "No embedding model.",
        "unknown": "Embedding model use unknown."
      },
      "unknownLimit": "?"
    },
    "tools": "MCP tools offered, read on demand",
    "unbound": "not bound in this process schema",
    "unreadable": "This step's definition could not be read.",
    "untitledSection": "Before the first heading",
    "writes": "Writes",
    "writesMarker": "writes"
  },
  "density": {
    "help": {
      "compact": "Kind and name only",
      "detailed": "Also what each step does; every input starts expanded",
      "standard": "Kind, name and one key fact"
    },
    "label": "How much each card shows",
    "options": {"compact": "Compact", "detailed": "Detailed", "standard": "Standard"},
    "short": "Cards:"
  },
  "details": {
    "after": "{{start}}, after step {{step}}",
    "budget": "At most {{count, number}} input tokens.",
    "capabilities": {
      "reasoning": "reasoning",
      "text": "text",
      "tools": "tools",
      "vision": "images"
    },
    "contextWindow": "a {{count, number}}-token context",
    "corpus": "the corpus",
    "earlierResults": "earlier results of this Run",
    "editNamed": "Edit {{name}}",
    "entry": "The document or segment being worked on",
    "fromStep": "from step {{step}}, {{part}}",
    "givesAnnotations": {
      "content_change_set": "annotations, {{need}}, saved as a content change set",
      "knowledge_data": "annotations, {{need}}, saved into the knowledge data",
      "thread_log": "annotations, {{need}}, kept in the Run"
    },
    "givesChangeSet": "a change set of {{kinds}}, {{need}}",
    "givesInstanceData": "statements, {{need}}",
    "givesText": "an answer in text",
    "labels": {
      "agent": "Agent",
      "answer": "Answer",
      "asks": "Asks",
      "does": "Does",
      "filled": "Filled with",
      "from": "From",
      "gives": "Gives",
      "holds": "Holds",
      "kind": "Kind",
      "madeBy": "Made by",
      "mayCall": "May call",
      "prompt": "Prompt",
      "reads": "Reads",
      "skills": "Skills",
      "starts": "Starts",
      "tool": "Tool",
      "version": "Version",
      "with": "With"
    },
    "list": "{{first}} and {{last}}",
    "needs": "Needs {{needs}}.",
    "openPrompt": "Open the prompt",
    "promptVersion": "prompt {{version}}",
    "proposes": "proposes “{{name}}” for review",
    "render": {"numbered_segments": "in numbered segments", "plain": "as plain text"},
    "sections_one": "({{count}} section)",
    "sections_other": "({{count}} sections)",
    "session": {
      "isolated": "Own session.",
      "thread": "Run session: earlier turns stay in its context."
    },
    "shortenedFirst": "Shortened first: {{inputs}}.",
    "skillUse": {"offered": "offered", "requested": "requested"},
    "start": {"automatic": "Automatically", "on_request": "On request"},
    "stepVersion": "step version {{version}}",
    "termFilter": {
      "all": "all terms",
      "labels_matching_subject": "terms whose labels match the document or segment"
    },
    "unbound": "nothing bound",
    "whole": "whole",
    "wholeContentVersion": "the whole content version",
    "wholeDataModel": "the whole data model"
  },
  "edit": {
    "about": "About",
    "aboutDescription": "Description",
    "aboutName": "Name",
    "addExport": "Add a result",
    "addInput": "+ input",
    "addInputNamed": "Add {{name}} as an input",
    "addMain": "+ main sequence",
    "addMainNamed": "Add {{name}} to the main sequence",
    "added": "Added {{name}} ({{role}}).",
    "bound": "Bound {{target}} ← {{source}}.",
    "changeSetTitle": "Change process schema: {{name}}",
    "changedChip": "changed",
    "changes": "Changes in this draft",
    "close": "Close the editor",
    "defaultValue": "Default value",
    "discard": "Discard",
    "discarded": "The draft is back at the version you started from.",
    "editStep": "Edit step…",
    "exportName": "Name of the result",
    "exportNameProblem": "Use a new name of lower case letters, digits and _.",
    "exportPart": "Part",
    "exports": "Results of the process schema",
    "graphLabel": "Process schema graph, edit mode",
    "inThread": "Edit in a Run…",
    "inputs": "Inputs",
    "invalidBinding": "{{source}} (does not fit)",
    "key": "Key {{key}}",
    "loading": "Opening the editor…",
    "moveEarlier": "Move earlier",
    "moveLater": "Move later",
    "newStep": "New step…",
    "noExports": "No results: a process schema that uses this one as a sub-schema gets none of its outputs.",
    "noOtherInputs": "none in this process schema",
    "noSources": "No earlier output fits this input.",
    "notSaved": "not saved",
    "nothingToAdd": "The draft has no changes yet.",
    "open": "Edit…",
    "openSubWorkflow": "Open the sub-schema",
    "paletteHint": "Drag onto the main sequence or the input preparation above it, or use the buttons. A process schema becomes a sub-schema.",
    "picker": {
      "empty": "There are no steps to add yet.",
      "gives": "Gives",
      "groups": {"own": "This project", "workflows": "Process schemas, as sub-schemas"},
      "library": "Library: {{name}}",
      "loading": "Reading the steps this project can use…",
      "noMatch": "No step matches the search.",
      "nothing": "nothing",
      "search": "Search by name or type",
      "takes": "Takes",
      "title": "Add a step"
    },
    "problemChip_one": "{{count}} problem",
    "problemChip_other": "{{count}} problems",
    "problemsNotice": "The draft has problems. It can still go into a change set as work in progress; the review shows them.",
    "problems_one": "{{count}} problem",
    "problems_other": "{{count}} problems",
    "proposed": "proposed",
    "reading": "Reading step versions…",
    "refusals": {
      "kindsDoNotFit": "Cannot bind here: {{target}} accepts none of {{kinds}}. Inputs that do: {{others}}.",
      "noSuchPart": "Cannot bind from {{source}}: the step has no such output.",
      "noSuchSlot": "Cannot bind {{target}}: the step has no such input.",
      "noSuchStep": "Cannot bind {{target}}: the step is not in this process schema.",
      "notEarlier": "Cannot bind {{target}} ← {{source}}: the source must be an earlier step.",
      "sameStep": "Cannot bind {{target}} to its own step.",
      "unknownPorts": "Cannot bind yet: the steps' versions are still being read."
    },
    "remove": "Remove",
    "removeExportNamed": "Remove the result {{name}}",
    "repinned_one": "{{keys}} now runs the new step version.",
    "repinned_other": "{{keys}} now run the new step version.",
    "reviewNotice": "Checks run on the change set's current version; curators of process schemas decide.",
    "role": "Step role",
    "roles": {"input": "input preparation", "main": "main sequence"},
    "saved": "in a change set",
    "selectHint": "Choose a step's name in the graph to set its step role, start and inputs. Drag from an output (on a card's right side or bottom edge) to an input (on its left side or top) to bind.",
    "selectNamed": "Select {{name}}",
    "start": "Start",
    "starts": {"automatic": "automatic", "on_request": "on request"},
    "status": "Editing a draft of @{{version}}",
    "stepVersion": "Step",
    "toolbar": "Editor",
    "unbound": "not bound",
    "workflowVersion": "Sub-schema"
  },
  "graph": {
    "controls": "Zoom controls",
    "edgeHint": "Connection between two steps.",
    "fitView": "Fit the graph to the canvas",
    "label": "Process schema graph",
    "nodeHint": "Choose a name to open it.",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out"
  },
  "index": {"intro": "Choose a process schema in the sidebar.", "new": "Make something new"},
  "inputCard": {
    "edit": "Edit",
    "shownAs": "Shown as {{view}}; only {{type}} fits",
    "version": "Version {{version}}"
  },
  "layout": {
    "help": {
      "horizontal": "The steps run left to right",
      "vertical": "The steps run top to bottom"
    },
    "label": "Which way the steps run",
    "options": {"horizontal": "Horizontal", "vertical": "Vertical"},
    "short": "Direction:"
  },
  "legend": {
    "help": "What each mark means",
    "label": "What the marks mean",
    "meanings": {
      "inputNeed": "Solid outline: a value must be there before the step runs; a default can provide it. Dotted: the step can run without one.",
      "passesResult": "An earlier step's output fills this input. The line carries a value.",
      "personInput": "A person gives one of this step's inputs before it runs: no earlier step, default or Run data covers it.",
      "portLabel": "What the port is for, then what it takes or gives in words, such as Text or Annotations. “Type not declared”: the step's definition names none.",
      "readsSaved": "A saved or prepared input from the band above fills this input. It is still data.",
      "then": "This step follows that step. The line passes no value.",
      "unused": "Nothing in this process schema uses this output. The output is not missing, and the step is not optional.",
      "waitsForRun": "This step starts only when you choose Run. Its data lines keep their own style."
    },
    "portSample": "corpus · Text",
    "rule": "Circles are ports. Arrows show direction. Crossings do not connect.",
    "samples": {
      "inputNeed": "Required, optional input",
      "passesResult": "Passes a result",
      "portLabel": "Name · data type",
      "readsSaved": "Reads a saved input",
      "then": "Then",
      "unused": "Output not used later",
      "waitsForRun": "Optional, on request"
    }
  },
  "library": {
    "empty": "This project has no process schemas yet. Create one from a Run, or propose one in a change set.",
    "loading": "Loading process schemas…"
  },
  "list": {
    "groups": {
      "basis": "DMW basis",
      "favourites": "Favourites",
      "kind": "{{origin}} · {{kind}}",
      "parts_one": "{{count}} part of other process schemas",
      "parts_other": "{{count}} parts of other process schemas",
      "project": "This project",
      "recent": "Recently used"
    },
    "noMatch": "No process schema matches the search.",
    "partOf": "Part of {{workflows}}",
    "search": "Search process schemas",
    "star": "Add {{workflow}} to favourites",
    "unstar": "Remove {{workflow}} from favourites"
  },
  "node": {
    "allQuestions": "All competency questions",
    "builtBy": "Built by a Run of “{{workflow}}”; this version was made by hand",
    "builtInTool": "Built-in tool {{tool}}",
    "collapse": "Collapse",
    "collapseNamed": "Collapse {{name}}",
    "expand": "Expand",
    "expandNamed": "Expand {{name}}",
    "facts": {
      "annotations": "Writes annotations with the labels",
      "annotationsToData": "Writes annotations into the knowledge data",
      "answer": "Writes an answer",
      "builtInTool": "Built-in {{tool}}, {{model}}",
      "changeSet": "Proposes a change set for curator review",
      "changeSetOptional": "Can propose a change set for review",
      "choice": "Chooses one of: {{options}}",
      "decideResults": "Curators accept or reject the result",
      "examples": {
        "all": "all examples",
        "matching_subject": "examples that match the document or segment"
      },
      "fewShot_one": "At most {{count}} example",
      "fewShot_other": "At most {{count}} examples",
      "instanceData": "Writes statements for review",
      "itemWhole": "Read whole",
      "keepMemory": "A person keeps the passages as a memory",
      "labels_one": "{{count}} label",
      "labels_other": "{{count}} labels",
      "proposeChange": "Edit and save a change set",
      "questions_one": "{{count}} question",
      "questions_other": "{{count}} questions",
      "releasePart": "Fills in the release request: {{part}}",
      "review": "Correct and confirm, comment optional",
      "reviewChangeSet": "Curators decide the change set",
      "reviewMemory": "Someone who may approve confirms or discards the memory",
      "reviewWithComment": "Correct and confirm, with a comment",
      "subWorkflow_one": "{{count}} step: {{steps}}",
      "subWorkflow_other": "{{count}} steps: {{steps}}",
      "taggedQuestions": "Tagged {{tags}}",
      "termProperties": "With {{properties}}",
      "termPropertiesFrom": "With the properties “{{item}}” names",
      "termRender": {"term_cards": "As term cards", "turtle": "As Turtle"},
      "text": "Answers in text",
      "tool": "{{tool}}, {{model}}",
      "unboundOptional": "May stay empty",
      "withGuidelines": "with guidelines",
      "withSparql": "with SPARQL",
      "withoutSparql": "without SPARQL",
      "workspaceFile": "Hands in a file ({{suffixes}})"
    },
    "gives": "Gives {{ports}}",
    "hideSettingsNamed": "Hide the settings of {{name}}",
    "isCollapsed": "Collapsed",
    "isExpanded": "Expanded",
    "isInput": "Input preparation",
    "kinds": {
      "abstract_step": "Abstract step",
      "artifact": "Artifact",
      "sub_workflow": "Sub-schema",
      "terms": "Ontology terms",
      "unreadable": "Could not be read"
    },
    "madeBy": "Made by a Run of “{{workflow}}”",
    "madeByHand": "Made by hand",
    "number": "Step {{number}}",
    "onRequest": "Optional, on request",
    "openProducer": "Process schema",
    "openProducerNamed": "Open the process schema that makes {{name}}",
    "openProducerThread": "Run",
    "openProducerThreadNamed": "Open the Run that made {{name}}",
    "port": {
      "empty": "(empty)",
      "many": "Several: {{type}}",
      "needs": {
        "optional": "Optional",
        "required": "Required",
        "undeclared": "Not declared whether required"
      },
      "optional": "optional",
      "required": "required",
      "typeNotDeclared": "Type not declared",
      "typeUnion": "{{kinds}} or {{last}}",
      "unfilled": "nothing fills it",
      "unused": "no later step uses it",
      "used": "a later step uses it"
    },
    "projectTool": "Project tool",
    "releaseParts": {
      "metadata": "title, licence and description",
      "what": "what goes in",
      "where": "where it goes"
    },
    "results": {
      "annotations": "annotations",
      "change_set": "change set",
      "choice": "choice",
      "instance_data": "statements",
      "reviewed": "reviewed",
      "workspace_file": "file"
    },
    "selectors": {
      "competency_questions": "Competency questions",
      "few_shot_examples": "Few-shot examples",
      "label_list": "Label list"
    },
    "showInThread": "In Run",
    "showInThreadNamed": "Show {{name}} in the Run",
    "showSettingsNamed": "Show the settings of {{name}}",
    "state": "State: {{state}}",
    "steps_one": "{{count}} step",
    "steps_other": "{{count}} steps",
    "takes": "Takes {{ports}}",
    "termKinds": {
      "annotation_property": "Annotation properties",
      "class": "Classes",
      "datatype_property": "Datatype properties",
      "individual": "Individuals",
      "object_property": "Object properties"
    },
    "termKindsAll": "Terms",
    "termKindsMany": "{{first}} and {{last}}",
    "termsOfModel": "{{kinds}} of the data model",
    "termsOfModules": "{{kinds}} of {{modules}}"
  },
  "outline": {
    "feeds": "Feeds: {{steps}}",
    "inputs": "Input preparation",
    "pipeline": "Main sequence"
  },
  "view": {
    "collapseAll": "Collapse all inputs",
    "definition": "Show the definition",
    "display": "Display",
    "displays": {"graph": "Graph", "list": "List"},
    "expandAll": "Expand all inputs",
    "loading": "Loading the process schema…",
    "run": "Start a Run…"
  }
}
